export default "__VITE_ASSET__CvF1kFw3__"